"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getWeatherForecastOperation_1 = require("owa-service/lib/operation/getWeatherForecastOperation");
var getWeatherForecastRequest_1 = require("owa-service/lib/factory/getWeatherForecastRequest");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function getWeatherForecastService(weatherLocationId, temperatureUnit) {
    return getWeatherForecastOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: getWeatherForecastRequest_1.default({
            WeatherLocationIds: weatherLocationId,
            TemperatureUnit: temperatureUnit,
        }),
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = getWeatherForecastService;
//# sourceMappingURL=getWeatherForecastService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-upnext/lib/services/getWeatherForecastService.js
// module id = 4819
// module chunks = 48